import { render, staticRenderFns } from "./grid-item.vue?vue&type=template&id=2d90036a&scoped=true&"
import script from "./grid-item.vue?vue&type=script&lang=js&"
export * from "./grid-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d90036a",
  null
  
)

export default component.exports